import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerServiceWorker } from './pwa';
import { installNativeFilePicker } from './services/nativeFilePicker';
import { installFrontendErrorLogging } from './services/axiomLogger';

registerServiceWorker();
installNativeFilePicker();
installFrontendErrorLogging();

// Reload the app when it returns from background after a meaningful absence.
// - Always reloads if the WKWebView content process was terminated (root is empty).
// - Reloads after >10s away so users coming back to the app see fresh data.
// - Quick switches (<10s) keep the current page so glancing away isn't jarring.
const FOREGROUND_RELOAD_THRESHOLD_MS = 300_000; // 5 minutes
let hiddenAt = Date.now();
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') {
    hiddenAt = Date.now();
  } else if (document.visibilityState === 'visible') {
    // Only apply recovery and time-based reloads on mobile/standalone apps
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isStandalone || isMobile) {
      const rootEl = document.getElementById('root');
      const elapsed = Date.now() - hiddenAt;

      // Always restore if the WKWebView content process was terminated
      if (elapsed > 500 && rootEl && !rootEl.hasChildNodes()) {
        window.location.reload();
        return;
      }

      // Skip automatic foreground reloads on checkout, support, and collab pages
      // to preserve typed card details, passwords, and form state when users
      // switch apps (e.g. to password managers or credit card vaults).
      const path = window.location.pathname.toLowerCase();
      const isCheckoutPage = path.includes('/shoutout') || path.includes('/support') || path.includes('/collab') || path.includes('/checkout');

      if (!isCheckoutPage && elapsed >= FOREGROUND_RELOAD_THRESHOLD_MS) {
        window.location.reload();
      }
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
